module.exports = __webpack_public_path__ + "static/img/图层 49.7f60f1ed.png";